<template>
  <v-container grid-list-xs>
    <v-card>
      <v-tabs v-model="tabInvoices" color="deep-purple-accent-4" align-tabs="center">
        <v-tab value="pendingInvoices">Contas a pagar</v-tab>
        <v-tab value="paidInvoices">Contas pagas</v-tab>
      </v-tabs>
      <v-window v-model="tabInvoices">
        <v-window-item value="pendingInvoices">
          <v-row v-if="lstGroupObjects && lstGroupObjects.length > 0">
            <v-col cols="12" v-for="(groupInvoice, ixginv) in lstGroupObjects" :key="ixginv">
              <v-card>
                <v-card-item>
                  <v-card-title>{{ groupInvoice[0].to.name }}</v-card-title>
                </v-card-item>

                <v-card-text>
                  <v-card v-for="(group2, ixginv) in groupByCategory(groupInvoice)" :key="ixginv">
                    <v-card-item>
                      <v-card-title>{{ group2[0].category }}</v-card-title>
                    </v-card-item>

                    <v-card-text>
                      <v-table density="compact">
                        <thead>
                          <tr>
                            <th class="text-left"></th>
                            <th class="text-left">Cod.</th>
                            <th class="text-left">Referência</th>
                            <th class="text-center">Vencimento</th>
                            <th class="text-right">Valor</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="item in group2" :key="item.id"
                            :class="getTextColorClassFromInvoice(item)">
                            <v-tooltip v-if="shouldDisablePayment(item)" 
                                activator="parent" 
                                target="cursor"
                                location="top">
                                Autorização pendente para este evento
                            </v-tooltip>
                            <td class="text-left">
                              <v-checkbox v-model="selectedInvoices" :value="item" hide-details density="compact"
                                :disabled="requestingApi || shouldDisablePayment(item)">
                              </v-checkbox>
                            </td>
                            <td class="text-left">{{ item.id }}</td>
                            <td class="text-left">{{ item.description }}</td>
                            <td class="text-center">
                              {{
                              $moment.parseZone(item.due_date).format("DD/MM/YYYY")
                              }}
                            </td>
                            <td class="text-right">
                              {{
                              $filters.currency(getAmountFromInvoice(item), "BRL")
                              }}
                            </td>
                          </tr>
                        </tbody>
                      </v-table>
                    </v-card-text>
                  </v-card>
                </v-card-text>
              </v-card>
            </v-col>
            <v-col cols="6" class="pa-5">
              <p class="text-h4">Total a pagar</p>
            </v-col>
            <v-col cols="6" class="pa-5">
              <p class="text-h5 text-right">
                {{ $filters.currency(totalInvoices, "BRL") }}
              </p>
            </v-col>
            <v-col cols="12" class="text-center mb-5">
              <v-btn :disabled="disablePayment" @click="initiateCheckout" color="primary">Realizar Pagamento</v-btn>
            </v-col>
          </v-row>

          <v-row v-else>
            <v-col cols="12" class="text-center my-5">
              <p class="text-h5">Nenhum lançamento pendente.</p>
            </v-col>
          </v-row>
        </v-window-item>
        <v-window-item value="paidInvoices">
          <InvoiceHistory :user="user" />
        </v-window-item>
      </v-window>
    </v-card>
  </v-container>
</template>
<script>
import DialogWriteOff from "@/components/DialogWriteOff.vue";
import AutocompleteSelectGroup from "../components/AutocompleteSelectGroup.vue";
import AutocompleteSelectInvoiceStatus from "../components/AutocompleteSelectInvoiceStatus.vue";
import DialogCreateInvoice from "../components/DialogCreateInvoice.vue";
import AutocompleteSelectLegalPeople from "@/components/AutocompleteSelectLegalPeople.vue";
import InvoiceHistory from "@/components/InvoiceHistory.vue";
import api from '@/services'
import { groupObjectsByKey } from '@/services/Functions'
export default {
  components: {
    AutocompleteSelectGroup,
    AutocompleteSelectInvoiceStatus,
    DialogCreateInvoice,
    DialogWriteOff,
    AutocompleteSelectLegalPeople,
    InvoiceHistory,
  },
  props: {
    user: Object,
  },
  data() {
    return {
      requestingApi: false,
      tab: 1,
      headers: [
        { title: "ID", align: "start", key: "id", sortable: true },
        { title: "Status", align: "start", key: "status", sortable: true },
        { title: "Descrição", align: "start", key: "description", sortable: true },
        { title: "De", align: "start", key: "from.name", sortable: true },
        { title: "Para", align: "start", key: "to.name", sortable: true },
        { title: "Valor", align: "end", key: "amount", sortable: true },
        { title: "Vencimento", align: "end", key: "due_date", sortable: true },
        { title: "Pagamento", align: "end", key: "payment_date", sortable: true },
        { title: "Ações", key: "actions", align: "end", sortable: false },
      ],
      selectedHeaders: [],
      lstObjects: [],
      lstGroupObjects: [],
      selectedInvoices: [],
      tabInvoices: "pendingInvoices",
      filters: {
        withUser: true,
        special_filters: [],
        statuses: [],
        itemsPerPage: 1,
        is_human: null,
        type: null,
        group_id: null,
        legal_people_to_ids: [],
      },
      editModel: {},
      newInvoiceRequest: {
        invoice: {},
      },
      checkout: {
        payment_method: {},
        payment_date: new Date(),
        invoices: [],
        invoice: {},
        invoices_ids: [],
        validation: {
          total: 0,
        },
      },
      dialogCreateEdit: false,
      searchFilter: null,
      page: 1,
      maxPage: 1,
    };
  },
  created() {
    var vm = this;

    vm.loadParameters();
  },
  mounted() { },
  activated() {
    var vm = this;

    if (vm.$route?.query?.it) {
      vm.tabInvoices = vm.$route.query.it;
    }
    vm.fetchPendingInvoices();
  },
  methods: {
    getTextColorClassFromInvoice(invoice) {
      var vm = this;
      let _class = "";
      if (invoice.status == vm.$INVOICE_STATUS_DIC.CANCELED.value) {
        _class = "";
      } else {
        let _dueDate = vm.$moment.parseZone(invoice.due_date).startOf("day");
        if (invoice.payment_date) {
          let _paymentDate = vm.$moment
            .parseZone(invoice.payment_date)
            .startOf("day");
          if (_dueDate < _paymentDate) {
            _class = "text-red";
          } else if (
            _dueDate.format("DD/MM/YYYY") == _paymentDate.format("DD/MM/YYYY")
          ) {
            _class = "text-orange";
          } else if (_dueDate > _paymentDate) {
            _class = "text-green";
          }
        } else {
          let _today = vm.$moment.parseZone().startOf("day");
          if (_dueDate < _today) {
            _class = "text-red";
          } else if (
            _dueDate.format("DD/MM/YYYY") == _today.format("DD/MM/YYYY")
          ) {
            _class = "text-orange";
          } else if (_dueDate > _today) {
            _class = "text-blue";
          }
        }
      }
      
      if (vm.shouldDisablePayment(invoice)){
        _class = "text-grey";
      }
      return _class;
    },
    shouldDisablePayment(invoice){
      return invoice?.event && !invoice?.event?.authorizations?.map(ea => ea.invitee_id).includes(invoice?.to?.id);
    },
    getAmountFromInvoice(invoice) {
      var vm = this;
      if (invoice.paid_amount) {
        return invoice.paid_amount;
      } else {
        let _dueDate = vm.$moment.parseZone(invoice.due_date).startOf("day");
        let _today = vm.$moment.parseZone().startOf("day");
        let _amount = invoice.amount;
        if (_dueDate > _today) {
          _amount -= invoice.early_payment_discount || 0;
        } else if (
          _dueDate.format("DD/MM/YYYY") == _today.format("DD/MM/YYYY")
        ) {
          _amount -= invoice.early_payment_discount || 0;
        }
        return _amount;
      }
    },
    initiateCheckout() {
      var vm = this;
      vm.requestingApi = true;
      let _lstInvoiceIds = vm.selectedInvoices.map(obj => obj.id);
      api.checkout
        .initiate({ invoiceIds: _lstInvoiceIds, due_amount: vm.totalInvoices.toFixed(2) })
        .then((result) => {
          let _oldCheckout = result?.oldCheckout || null;
          let _checkoutData = result?.data || null;
          // Check dueAmount and send informations
          // btoa(JSON.stringify(_checkoutData)
          if (_oldCheckout) {
            vm.$notify({
              type: "warn",
              text: 'Existe um pagamento em aberto. Finalize ou cancele o pagamento antes de criar um novo.',
            });
            vm.$router.push({ name: 'Checkout', query: { checkout: _oldCheckout.id } })
          } else {
            vm.$router.push({ name: 'Checkout', query: { checkout: _checkoutData.id } })
          }
        })
        .catch((err) => {
          if (err.message) {
            vm.$notify({
              type: "warn",
              text: err.message,
            });
          }
        })
        .finally(() => {
          vm.requestingApi = false;
        });
    },
    saveSelectedHeaders() {
      var vm = this;
      try {
        localStorage.setItem(
          "_my_invoices_list_headers",
          JSON.stringify(vm.selectedHeaders)
        );
      } catch (error) {
        console.error(error);
      }
    },
    selectedGroup(group) {
      var vm = this;
      vm.filters.group_id = group?.id;
    },
    loadParameters() {
      var vm = this;
      let _itemsPerPage = localStorage["_my_invoices_itemsPerPage"];
      vm.filters.itemsPerPage = parseInt(_itemsPerPage || 10);

      try {
        let _headers = localStorage["_my_invoices_list_headers"];
        vm.selectedHeaders = _headers ? JSON.parse(_headers) : vm.headers;
      } catch (error) {
        vm.selectedHeaders = vm.headers;
      }
    },
    clearFilters() {
      var vm = this;
      vm.filters.searchText = null;
      vm.searchFilter = null;
      vm.filters.special_filters = [];
    },
    groupByCategory(lstInvoices) {
      var vm = this;
      return groupObjectsByKey(lstInvoices, "category");
    },
    fetchPendingInvoices(page) {
      var vm = this;
      vm.selectedInvoices = [];
      if (!vm.requestingApi) {
        vm.requestingApi = true;
        vm.page = page || 1;
        vm.filters.statuses = vm.$PAYABLE_INVOICE_STATUSES
        return new Promise((resolve, reject) => {
          api.invoice
            .myPendingInvoices(vm.filters)
            .then((result) => {
              vm.lstObjects = (result?.data || []).map((el) => {
                el.category = el?.categories && el.categories.length > 0
                  ? el.categories.sort((c1, c2) => c2.parent_category_id - c1.parent_category_id)[0].name
                  : null;
                el['isService'] = el?.type === vm.$INVOICE_TYPE_DIC.SERVICE.value;
                return el;
              }).sort((a, b) => {
                if (a.isService && !b.isService) {
                  return -1;
                } else if (!a.isService && b.isService) {
                  return 1;
                }
                if (vm.$moment(a.due_date).isBefore(vm.$moment(b.due_date))) {
                  return -1;
                } else if (vm.$moment(a.due_date).isAfter(vm.$moment(b.due_date))) {
                  return 1;
                }
                return 0;
              });
              vm.lstGroupObjects = groupObjectsByKey(
                vm.lstObjects,
                "legal_person_to"
              );
            })
            .catch((err) => {
              if (err.message) {
                vm.$notify({
                  type: "warn",
                  text: err.message,
                });
              }
            })
            .finally(() => {
              vm.requestingApi = false;
            });
        });
      }
    },

    createdObject(val) {
      var vm = this;
      vm.lstObjects.unshift(val);
    },
    updatedObject(val) {
      var vm = this;
      let _ixEdited = vm.lstObjects.findIndex((x) => x.id === val.id);
      let _merge1 = vm.lstObjects[_ixEdited];
      let _merge = {
        ..._merge1,
        ...val,
      };
      vm.lstObjects[_ixEdited] = _merge;
    },
  },
  computed: {
    disablePayment() {
      const vm = this;

      return vm.requestingApi || (vm.selectedInvoices.some(o => o.isService) && vm.selectedInvoices.some(o => !o.isService)) || vm.selectedInvoices?.length === 0;
    },
    amountDue() {
      var vm = this;
      return function (invoice) {
        let _dueDate = vm.$moment.parseZone(invoice.due_date);
        if (_dueDate < vm.$moment.parseZone(vm.value?.payment_date)) {
          return invoice.amount;
        } else {
          return invoice.amount - (invoice.early_payment_discount || 0);
        }
      };
    },
    totalInvoices() {
      var vm = this;
      let _paymentDate = vm.$moment.parseZone(new Date());

      if ((vm.selectedInvoices || []).length > 0) {
        return +vm.selectedInvoices?.reduce((acc, curr) => {
          let _dueDate = vm.$moment(curr.due_date.substring(0, 10));
          let _discount = curr.early_payment_discount || 0;

          return (
            acc +
            (vm.$moment(_paymentDate).isSameOrBefore(_dueDate, 'day') ? curr.amount - _discount : curr.amount)
          );
        }, 0);
      } else {
        // no invoices found, return 0 as default value
        return 0;
      }
    },
    invoiceIds() {
      var vm = this;
      let _invoiceIds = [];
      if (vm.value?.invoice?.id) {
        _invoiceIds.push(vm.value?.invoice?.id);
      } else if (vm.value?.invoices) {
        _invoiceIds = vm.value?.invoices.map((i) => i.id);
      }
      return _invoiceIds;
    },
  },
  watch: {
    "filters.itemsPerPage"(newVal) {
      localStorage["_my_invoices_itemsPerPage"] = newVal;
    },
    page(newVal) {
      var vm = this;
      if (!isNaN(newVal)) {
        vm.submitSearch(newVal);
      }
    },
  },
};
</script>